var RowOperation;
(function (RowOperation) {
    RowOperation[RowOperation["None"] = 0] = "None";
    RowOperation[RowOperation["RowAdd"] = 1] = "RowAdd";
    RowOperation[RowOperation["RowMove"] = 2] = "RowMove";
    RowOperation[RowOperation["RowDelete"] = 3] = "RowDelete";
    RowOperation[RowOperation["RowUpdateInPlace"] = 4] = "RowUpdateInPlace";
})(RowOperation || (RowOperation = {}));
export default RowOperation;
//# sourceMappingURL=RowOperation.js.map